import z from 'zod';

export const SchoolTicketViewSchema = z.object({
  description: z.string().optional(),
  name: z.string().min(1, 'Nome é obrigatório'),
  timeOfTicket: z.string().optional(), 
  cpf: z.string().optional(),
  phone: z.string().optional(),
  image: z.string().optional(),
  responsibleId: z.string().optional(), 
  isValid: z.boolean().optional(),
  studentIds: z.array(z.number()).min(1, 'Selecione pelo menos um aluno'), 
});

export type SchoolTicketFormInput = z.infer<typeof SchoolTicketViewSchema>;